import * as React from 'react';
import {Shop} from 'interfaces/Shop';
import {Icon} from 'components/UIKit/Icon';

import shopIcons from 'components/ShopDisplay/icons';

import DesktopNewTabAnchor from 'components/DesktopNewTabAnchor';
import {ShopBanner} from '..';

export interface Props {
  shop: Shop;
}

export default function ShopScreenshot(props: Props) {
  let image: React.ReactChild;

  if (props.shop.isPrivate) {
    image = (
      <Icon
        className="shop-tile__no-image-icon"
        fill="#fff"
        size={48}
        sourceSVG={shopIcons.lock}
      />
    );
  } else if (props.shop.shopScreenshotData) {
    image = (
      <img
        sizes="100vw"
        data-srcset={props.shop.shopScreenshotData.data.srcset}
        className={props.shop.shopScreenshotData.class}
        alt={props.shop.shopScreenshotData.alt}
      />
    );
  } else {
    image = (
      <Icon
        sourceSVG={shopIcons.camera}
        size={40}
        className="shop-tile__no-image-icon"
      />
    );
  }

  return (
    <DesktopNewTabAnchor href={`/shops/${props.shop.handle}`}>
      <div className={`shop-tile__image-wrapper ${props.shop.isPrivate ? 'background-slate' : 'background-purple-lighter'}`}>
        {image}
      </div>
      <ShopBanner shop={props.shop} />
    </DesktopNewTabAnchor>
  );
}
